import { useState, useEffect, useCallback } from 'react'
import { benefitRulesService } from '../services/benefitRulesService'
import type { BenefitStats } from '../types'

export function useBenefitStats() {
  const [stats, setStats] = useState<BenefitStats | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchStats = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const data = await benefitRulesService.getStats()
      setStats(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar estadísticas')
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchStats()
  }, [fetchStats])

  return { stats, isLoading, error, refetch: fetchStats }
}
